import { type FormEvent, useState } from "react";

export function usePasswordVerification(
  mode: "mfa-enable" | "reauthentication",
  generateMfa?: (password: string) => Promise<ArrayBuffer>,
  onSuccess?: (result: string) => void,
  validationErrors?: string | null | undefined,
  externalError?: string | null | undefined,
) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleChange = (value: string) => {
    setPassword(value);
    setError(undefined);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (password.length === 0) {
      setError(validationErrors ?? "Password is required");
      return;
    }

    setLoading(true);
    try {
      if (mode === "mfa-enable" && generateMfa) {
        const buffer = await generateMfa(password);
        const qrUrl = URL.createObjectURL(new Blob([buffer]));
        onSuccess?.(qrUrl);
      } else if (mode === "reauthentication") {
        onSuccess?.(password);
      }
    } catch (e) {
      setError(externalError ?? "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return {
    password,
    loading,
    error: error || externalError,
    handleChange,
    handleSubmit,
    setPassword,
    setError,
  };
}
